// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form{
   width: 600px;
   height: 600px;
}
.center {
   text-align: center;
}
.icon{
   margin: -35px auto -15px auto;
   display: block;
   width: 50%;
   max-width:100px;
   height:100px;
}
.agreement {
   display: block;
   margin: 0 auto 10px auto;
   overflow-x: auto;
   /*overflow-y: auto;*/
   border: 1px #ccc solid;
   width: 590px;
   height: 470px;
}
.agree-buttom{
   font-size: 16px;
   height: 30px;
   width: 80px;
   text-align: center!important;
   padding-left: 14px;
   border-radius: 14px;
}
.cancel-buttom{
   margin-right:10px;
   font-size: 16px;
   height: 30px;
   width: 80px;
   padding-left: 14px;
   text-align: center!important;
   border-radius: 14px;
}
.agreement-doc{
   width: 100%;
   height: 490px;
}
.text-header{
   font-weight: bold;
   font-size: 16px;
   padding-left: 10px;
   padding-bottom: 10px;
}
.text-main{
   font-weight: normal;
   font-size: 14px;
   margin-left: 12px!important;
   margin-right: 12px!important;
}
.text-terms{
   margin-left: -22px!important;
   font-weight: normal;
   font-size: 14px;
}
.text-indent{
   margin-top: 0!important;
   text-indent: 30px;
}
.text-indent-small{
   margin-top: 0!important;
   text-indent: 45px;
}
.text-indent-circle{
   margin-top: 0!important;
   text-indent: 55px;
}
h4{
   display:inline-block;
}
.block{
   display:block!important;
}
span{
   display:block!important;
}
#pdpa_block {
   padding: 1em 3em 3em;
   max-width: 999px;
   margin: 0 auto;
   margin-top: 30px;
}
.panel-margin {
   margin: 0 12px;
}
.headers-align .mat-expansion-panel-header-description {
   justify-content: end;
   align-items: center;
}

.agreement-panel {
   display: block;
   margin: 0 auto auto auto;
   width: 590px;
   height:auto;
}

.dialog-content{
   height: 470px;
   padding-bottom:2px;
   overflow-x: auto;
}

p.thick {
   font-weight: bold;
 }

.pdpa-panel {
   border: 1px #EEEDED solid;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/pdpa-policy/pdpa-policy.component.css"],"names":[],"mappings":"AAAA;GACG,YAAY;GACZ,aAAa;AAChB;AACA;GACG,kBAAkB;AACrB;AACA;GACG,6BAA6B;GAC7B,cAAc;GACd,UAAU;GACV,eAAe;GACf,YAAY;AACf;AACA;GACG,cAAc;GACd,wBAAwB;GACxB,gBAAgB;GAChB,oBAAoB;GACpB,sBAAsB;GACtB,YAAY;GACZ,aAAa;AAChB;AACA;GACG,eAAe;GACf,YAAY;GACZ,WAAW;GACX,4BAA4B;GAC5B,kBAAkB;GAClB,mBAAmB;AACtB;AACA;GACG,iBAAiB;GACjB,eAAe;GACf,YAAY;GACZ,WAAW;GACX,kBAAkB;GAClB,4BAA4B;GAC5B,mBAAmB;AACtB;AACA;GACG,WAAW;GACX,aAAa;AAChB;AACA;GACG,iBAAiB;GACjB,eAAe;GACf,kBAAkB;GAClB,oBAAoB;AACvB;AACA;GACG,mBAAmB;GACnB,eAAe;GACf,2BAA2B;GAC3B,4BAA4B;AAC/B;AACA;GACG,4BAA4B;GAC5B,mBAAmB;GACnB,eAAe;AAClB;AACA;GACG,uBAAuB;GACvB,iBAAiB;AACpB;AACA;GACG,uBAAuB;GACvB,iBAAiB;AACpB;AACA;GACG,uBAAuB;GACvB,iBAAiB;AACpB;AACA;GACG,oBAAoB;AACvB;AACA;GACG,uBAAuB;AAC1B;AACA;GACG,uBAAuB;AAC1B;AACA;GACG,oBAAoB;GACpB,gBAAgB;GAChB,cAAc;GACd,gBAAgB;AACnB;AACA;GACG,cAAc;AACjB;AACA;GACG,oBAAoB;GACpB,mBAAmB;AACtB;;AAEA;GACG,cAAc;GACd,wBAAwB;GACxB,YAAY;GACZ,WAAW;AACd;;AAEA;GACG,aAAa;GACb,kBAAkB;GAClB,gBAAgB;AACnB;;AAEA;GACG,iBAAiB;CACnB;;AAED;GACG,yBAAyB;AAC5B","sourcesContent":[".form{\n   width: 600px;\n   height: 600px;\n}\n.center {\n   text-align: center;\n}\n.icon{\n   margin: -35px auto -15px auto;\n   display: block;\n   width: 50%;\n   max-width:100px;\n   height:100px;\n}\n.agreement {\n   display: block;\n   margin: 0 auto 10px auto;\n   overflow-x: auto;\n   /*overflow-y: auto;*/\n   border: 1px #ccc solid;\n   width: 590px;\n   height: 470px;\n}\n.agree-buttom{\n   font-size: 16px;\n   height: 30px;\n   width: 80px;\n   text-align: center!important;\n   padding-left: 14px;\n   border-radius: 14px;\n}\n.cancel-buttom{\n   margin-right:10px;\n   font-size: 16px;\n   height: 30px;\n   width: 80px;\n   padding-left: 14px;\n   text-align: center!important;\n   border-radius: 14px;\n}\n.agreement-doc{\n   width: 100%;\n   height: 490px;\n}\n.text-header{\n   font-weight: bold;\n   font-size: 16px;\n   padding-left: 10px;\n   padding-bottom: 10px;\n}\n.text-main{\n   font-weight: normal;\n   font-size: 14px;\n   margin-left: 12px!important;\n   margin-right: 12px!important;\n}\n.text-terms{\n   margin-left: -22px!important;\n   font-weight: normal;\n   font-size: 14px;\n}\n.text-indent{\n   margin-top: 0!important;\n   text-indent: 30px;\n}\n.text-indent-small{\n   margin-top: 0!important;\n   text-indent: 45px;\n}\n.text-indent-circle{\n   margin-top: 0!important;\n   text-indent: 55px;\n}\nh4{\n   display:inline-block;\n}\n.block{\n   display:block!important;\n}\nspan{\n   display:block!important;\n}\n#pdpa_block {\n   padding: 1em 3em 3em;\n   max-width: 999px;\n   margin: 0 auto;\n   margin-top: 30px;\n}\n.panel-margin {\n   margin: 0 12px;\n}\n.headers-align .mat-expansion-panel-header-description {\n   justify-content: end;\n   align-items: center;\n}\n\n.agreement-panel {\n   display: block;\n   margin: 0 auto auto auto;\n   width: 590px;\n   height:auto;\n}\n\n.dialog-content{\n   height: 470px;\n   padding-bottom:2px;\n   overflow-x: auto;\n}\n\np.thick {\n   font-weight: bold;\n }\n\n.pdpa-panel {\n   border: 1px #EEEDED solid;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
